import styles from './Background.mobile.module.css';

export default function BackgroundMobileView() {
  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" className={styles.container}>
      <defs>
        <pattern id="dot-pattern" width="30" height="30" patternUnits="userSpaceOnUse">
          <rect width="30" height="30" fill="#F2F2F5" />
          <circle cx="15" cy="15" r="2" fill="#dcdcdc" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#dot-pattern)" />
    </svg>
  );
}
